import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { ESRI_ATTR, ESRI_TILES } from "@/lib/geo";

export function useLeafletMap(center, zoom) {
  const ref = useRef(null);
  const init = useRef({ center, zoom });
  const [map, setMap] = useState(null);
  useEffect(() => {
    const m = L.map(ref.current).setView(init.current.center, init.current.zoom);
    L.tileLayer(ESRI_TILES, { maxZoom: 21, maxNativeZoom: 19, attribution: ESRI_ATTR }).addTo(m);
    const timer = setTimeout(() => m.invalidateSize(), 300);
    setMap(m);
    return () => {
      clearTimeout(timer);
      m.remove();
    };
  }, []);
  return [ref, map];
}

export function useMapClick(map, enabled, onClick) {
  useEffect(() => {
    if (!map || !enabled) {
      return undefined;
    }
    const h = (e) => onClick(e.latlng);
    map.on("click", h);
    map.getContainer().style.cursor = "crosshair";
    return () => {
      map.off("click", h);
      map.getContainer().style.cursor = "";
    };
  }, [map, enabled, onClick]);
}
